import { PureComponent } from 'react';

export default class DLUnloader extends PureComponent {
    componentDidMount() {
        window.onbeforeunload = () => {
            if( !window.__dlUnloader ) {
                window.__dlUnloader = {};
            }
            Object.keys( window.__dlUnloader ).forEach( ( key ) => {
                window.__dlUnloader[ key ]();
            } );
        };
    }
    static register = ( key, func ) => {
        if( !window.__dlUnloader ) {
            window.__dlUnloader = {};
        }
        window.__dlUnloader[ key ] = func;
    }
    static unregister = ( key ) => {
        if( !window.__dlUnloader ) {
            window.__dlUnloader = {};
        }
        if( window.__dlUnloader[ key ] ) {
            delete window.__dlUnloader[ key ];
        }
    }
    render() {
        return null;
    }
}
DLUnloader.defaultProps = {
    permission: false,
};
